import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Atractivos } from "../components/site/Atractivos";
import { Metodologia } from "../components/site/Metodologia";
import { Servicios } from "../components/site/Servicios";
import { Testimonios } from "../components/site/Testimonios";
import { Contacto } from "../components/site/Contacto";
import { Footer } from "../components/site/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="bg-white text-[#3B3838] selection:bg-[#843C0C] selection:text-white">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Atractivos />
        <Metodologia />
        <Servicios />
        <Testimonios />
        <Contacto />
      </main>
      <Footer />
    </div>
  );
}
